// import ssc from './ssc';
// import xyrb from './xyrb';
// import pk10 from './pk10';
import lhc from "./lhc";

export default (type, data, ballindex, Vue) => {
  if (type == "lhc") {
    return lhc(data, ballindex);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  // if (type == 'PK10' || type == 'nn') {
  //   return pk10(data, ballindex);
  // }
  // if (type == 'ks') {
  //   return ks(data, ballindex);
  // }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/LhcJishikaijiang/columns/index.js